;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { createSerializer, parseAsString } from 'nuqs/server'

/**
 * `redirectTo` on `/login`. Missing param falls back to the dashboard,
 * matching the previous Zod default.
 */
export const loginPageParams = {
  redirectTo: parseAsString.withDefault('/dashboard'),
}

/**
 * Always write `redirectTo`, including when it equals the page default.
 * Otherwise a visit to `/dashboard` would drop the param and rely on the default.
 */
export const serializeLoginLink = createSerializer(loginPageParams, {
  clearOnDefault: false,
})

type SearchParamsLike = {
  readonly size: number
  toString(): string
}

/** Path plus the current page query, which `/login` stores in `redirectTo`. */
export function currentPageRedirectTo(
  pathname: string,
  searchParams: SearchParamsLike | null | undefined,
): string {
  if (!searchParams?.size) {
    return pathname
  }

  return `${pathname}?${searchParams.toString()}`
}

/**
 * Logging in from the homepage should return to the dashboard.
 * A missing pathname uses the same destination.
 * A default parameter only replaces `undefined`, so `null` is handled below.
 */
export function loginRedirectPathname(
  pathname: string | null = '/dashboard',
): string {
  if (pathname === null || pathname === '/') {
    return '/dashboard'
  }

  return pathname
}
